<header class="page-header">
  <div class="header-top-band" aria-hidden="true">
    <img class="header-top-band-image" src="/page-header/header-top-bg-desktop.svg" alt="" />
  </div>
  <svg class="header-border" viewBox="0 0 375 6" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M0 0H121.5L111.908 6H0V0Z" fill="#1758A7" />
    <path d="M92.9894 0H206L200.522 6H84.5L92.9894 0Z" fill="#002F7B" />
    <path d="M172.508 0H283.983L290.5 6H169L172.508 0Z" fill="#1746FF" />
    <path d="M375 0H253.5L262.048 6H375V0Z" fill="#38BEEF" />
  </svg>
  <div class="header-contents">
    <div class="header-main">
      <div class="header-logo-container">
        <button type="button" class="logo-btn" aria-label="オフィシャルHPを開く" (click)="openOfficialSite()" style="background: none; border: none; padding: 0; cursor: pointer">
          <img class="header-logo" src="/page-header/logo.svg" alt="第一生命" />
        </button>
      </div>
      <p class="header-title">変額保険ポータル</p>
    </div>
    <div class="header-actions" aria-label="ヘッダーリンク">
      <button class="header-link" type="button" (click)="onFaqClick()" aria-label="よくある質問を開く">
        <img class="header-link-icon" src="/mp0010/ic-help-circle.svg" aria-hidden="true" />
        <span>よくある質問</span>
      </button>
      <button class="header-link" type="button" (click)="onCloseWindowClick()" aria-label="ウィンドウを閉じる">
        <img class="header-link-icon" src="/nav-menu/close-window-icon.svg" alt="" aria-hidden="true" />
        <span>ウィンドウを閉じる</span>
      </button>
    </div>
    <button
      class="header-menu-icon"
      type="button"
      (click)="onMenuIconClick()"
      [attr.aria-label]="isMenuOpen() ? 'メニューを閉じる' : 'メニューを開く'"
      [attr.aria-expanded]="isMenuOpen()"
    >
      @if (isMenuOpen()) {
        <img class="header-menu-icon__close" src="/page-header/close.svg" alt="" aria-hidden="true" />
      } @else {
        <span class="header-menu-icon__bars" aria-hidden="true">
          <span class="header-menu-icon__bar"></span>
          <span class="header-menu-icon__bar"></span>
          <span class="header-menu-icon__bar"></span>
        </span>
        <span class="header-menu-icon__label">メニュー</span>
      }
    </button>
  </div>
</header>
